var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearSafetyHarness50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.125,15c1.655,0,3-1.345,3-3s-1.345-3-3-3s-3,1.345-3,3S20.47,15,22.125,15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.865,23.879l-1.875-4.125c-0.111-0.245-0.286-0.455-0.508-0.609l-3.353-2.337 C25.37,16.279,24.481,16,23.558,16h-1.917c-1.104,0-2.166,0.404-2.989,1.137L15.43,20H11.5c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5H16c0.367,0,0.722-0.135,0.996-0.379L19,20.84c0,0.649,0,1.401,0,2.16h7c0-0.969,0-1.942,0-2.626l1.43,0.997 l1.705,3.751C29.386,25.674,29.931,26,30.501,26c0.207,0,0.418-0.043,0.62-0.135C31.875,25.522,32.208,24.634,31.865,23.879z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.089,27.888l3.952-1.581L26,25.912c0-0.247,0-0.557,0-0.912h-7c0,0.382,0,0.721,0,1.034 L22.089,27.888z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.725,31.643l2.184-2.132l-3.103-1.862l-2.278,2.224c-0.463,0.452-0.639,1.122-0.457,1.743 l1.5,5.125c0.224,0.764,0.922,1.26,1.679,1.259c0.163,0,0.328-0.022,0.492-0.07c0.928-0.271,1.46-1.244,1.188-2.171L18.725,31.643z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.845,36.528l-2.259-4.991l-0.329-3.163l-3.573,1.429l0.472,2.519 c0.028,0.154,0.077,0.3,0.142,0.435l2.358,5.215C25.948,38.618,26.585,39,27.251,39c0.241,0,0.486-0.05,0.721-0.155 C28.852,38.446,29.243,37.409,28.845,36.528z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.997,9.007v1.846c0,2.278-0.539,4.514-1.533,6.538l0.161,0.112 c0.516,0.359,0.926,0.852,1.186,1.423l0.053,0.116c1.385-2.492,2.134-5.314,2.134-8.189v-0.572 C33.36,9.815,32.697,9.382,31.997,9.007z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearSafetyHarness50);
export default __webpack_public_path__ + "static/media/icons8-wear-safety-harness-50.163d4a2db7875f775510e20937f61332.svg";
export { ForwardRef as ReactComponent };